const BinSvg = ({ color }: { color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <g clipPath="url(#clip0_5274_76997)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 0.5C11.6 0.5 12 0.9 12 1.5V3.5H16V5.5H15V15.5C15 16.1 14.6 16.5 14 16.5H2C1.4 16.5 1 16.1 1 15.5V5.5H0V3.5H4V1.5C4 0.9 4.4 0.5 5 0.5H11ZM10 2.5H6V3.5H10V2.5ZM13 14.5V5.5H3V14.5H13ZM7 7.5H5V13.5H7V7.5ZM11 7.5H9V13.5H11V7.5Z"
          fill={color ?? "#1064DB"}
        />
      </g>
      <defs>
        <clipPath id="clip0_5274_76997">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BinSvg;
